import React from 'react';
import { onboardingQuestionsImage, onboardingQuestionsAudio } from '../../../utils/web-helper';
import * as S from './style';
import { useSelector } from 'react-redux'
import { isNewCoqAssigned } from '../../../utils/feature_mapping';

const Example = ({question, questionKey, playAudio, selectedSubject}) => {
 
  const { selectedGrade, gradeCodeMap } = useSelector(state => {
    return {
      selectedGrade: state.selectedGrade,
      gradeCodeMap: state.gradeCodeMap
    }
  });

  const playAudioHandler = (typeAudio) => {
    if(typeAudio) {
      playAudio(onboardingQuestionsAudio(question.illustration));
    }
  }

  const imageNotFoundHandler = (questionKey) => {
    const imageElement = document.getElementById(`question_img_${questionKey}`); 
    imageElement.style.display = 'none';
}

  if (question.illustration_type === 'image' || question.illustration_type === 'sound') {
    return (
      <>
        <img
          src={onboardingQuestionsImage({code: questionKey, subject: selectedSubject, grade: gradeCodeMap.get(selectedGrade).title})} 
          onClick={() => playAudioHandler(question.illustration_type === 'sound')}
          style={{cursor: question.illustration_type === 'sound' ? 'pointer' : 'default'}}
          onError = {() => imageNotFoundHandler(questionKey)}
          />
      </>
    )
  }

  else if (question.illustration_type === 'text') {
    return <S.ExampleText>{isNewCoqAssigned() ? question.illustration : question.illustration.slice(4)}</S.ExampleText>
  }

  else return null;
}

export default Example;